import { createMuiTheme } from "@material-ui/core";
import { FONT_SIZE_BASE } from "../contexts/ThemeContext";

const PALETTE = {
  branco: '#FFFFFF',
  preto: '#333333',
  amarelo: '#FFF333'
}

export const DarkTheme = (fontSize = FONT_SIZE_BASE) => {

  return createMuiTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: PALETTE.preto,
        light: '#5e92f3',
        dark: '#003c8f',
        contrastText: PALETTE.branco,
      },
      secondary: {
        main: PALETTE.amarelo,
        light: '#5e92f3',
        dark: '#003c8f',
        contrastText: PALETTE.branco,
        inputColor: PALETTE.branco
      },
      background: {
        default: PALETTE.preto,
        paper: PALETTE.preto,
        iconContrast: PALETTE.amarelo,
        iconContrastSecondary: PALETTE.amarelo,
        colorContrast: '#000',
        colorButtonHover: '#555555'
      },
      type: 'dark',
      corTexto: PALETTE.branco,
      corTitulo: PALETTE.amarelo,
      corIcone: PALETTE.branco,
      corIcone2: PALETTE.branco,
    },
    web: {
      LoginImpl: {
        upper: {
          background: PALETTE.preto
        }
      }
    },
    apps: {
      avaliacao: {
        color: PALETTE.branco,
        tooltip: {
          color: PALETTE.preto,
          backgroundColor: PALETTE.amarelo
        }
      },
      autenticidade: {
        template: {
          VerificarAutenticidade: {
            link: {
              color: `${PALETTE.amarelo} !important`
            },
          },
          ComoUsar: {
            span: {
              border: `2px solid ${PALETTE.amarelo}`,
            },
          },
        }
      },
      carteira: {
        imageDiv: {
          border: `2px dashed ${PALETTE.branco}`
        },
      },
      certificadoDeficiencia: {
        CertificadoDeficiencia: {
          text: {
            color: PALETTE.branco
          }
        }
      },
      declaracaoAtividade: {
        DeclaracaoAtividade: {
          text: {
            color: PALETTE.branco
          }
        },
      },
      extratoBeneficio: {
        ExtratoBeneficio: {
          root: {
            backgroundColor: PALETTE.preto,
          },
          label: {
            color: PALETTE.branco
          },
          situacao:{
            color: PALETTE.branco
          },
          text: {
            color: PALETTE.branco
          },
          icone: {
            color: PALETTE.amarelo
          },
          textNumero: {
            color: PALETTE.branco
          }
        }
      },
      extratoIR: {
        SelecaoAnoBeneficio: {
          label: {
            color: PALETTE.branco
          },
          selectYear: {
            color: PALETTE.branco
          }
        }
      },
      extratoPrevidenciario: {
        template: {
          MeuInssVinculoExpansionPanel: {
            nome: {
              color: PALETTE.branco
            },
            codigoEmpregador: {
              color: PALETTE.branco
            }
          },
          extratos: {
            LegendaIndicadores: {
              text: {
                color: PALETTE.branco
              },
              titulo: {
                color: PALETTE.branco,
              }
            }
          }
        }
      },
      hiscre:{
        ResultadoHiscre:{
          rubricas:{
            backgroundColor:PALETTE.preto,
          }
        }
      },
      meusBeneficios: {
        PaginaBeneficio: {
          detalhesBeneficios: {
            color: PALETTE.branco
          }
        }
      },
      nadaConsta: {
        NadaConsta: {
          root: {
            backgroundColor: PALETTE.preto
          },
          text: {
            color: PALETTE.branco
          }
        }
      },
      notificacao: {
        Notificacoes: {
          root: {
            backgroundColor: PALETTE.preto,
          },
          footer: {
            color: PALETTE.branco
          },
          subHeader: {
            color: PALETTE.preto,
            backgroundColor: PALETTE.branco,
          },
          containerTitulo: {
            color: PALETTE.branco
          },
          containerTituloMensagem: {
            color: PALETTE.branco
          },
          labelConteudoTitulo: {
            color: PALETTE.branco
          },
          containerMensagem: {
            color: PALETTE.branco
          },
          notificacaoNaoLida: {
            color: PALETTE.branco
          },
          labelConteudoData: {
            color: PALETTE.branco
          },
          labelConteudoMensagem: {
            color: PALETTE.branco
          },
          labelCaixaSemNotificacao: {
            color: PALETTE.branco
          }
        }
      },
      requerimentos: {
        templates: {
          CardRequerimento: {
            nameService: {
              color: PALETTE.branco
            }
          },
          ShowRequerimentos: {
            titulo: {
              color: PALETTE.branco
            }
          }
        }
      },
      simulador: {
        public: {
          template: {
            CardVinculo: {
              simulacaoCardNome: {
                color: PALETTE.branco,
              },
              simulacaoCardData: {
                color: PALETTE.branco,
              }
            },
          }
        },
        template: {
          FiliadoInfo: {
            box: {
              color: PALETTE.branco,
              backgroundColor: PALETTE.preto
            },
            value: {
              color: PALETTE.branco
            },
            selected: {
              color: PALETTE.branco,
              backgroundColor: PALETTE.preto,
              border: ''
            }
          },
          PainelDeDireitoWeb: {
            gridSimulacaoNome: {
              color: PALETTE.branco
            },
            simulacaoPossuiDireitoSim: {
              color: PALETTE.amarelo
            },
            simulacaoPossuiDireitoNao: {
              color: PALETTE.amarelo
            }
          },
          ResultadoCompleto: {
            header: {
              color: PALETTE.branco,
              backgroundColor: PALETTE.preto
            },
            detalhes: {
              label: {
                borderBottom: `1px solid ${PALETTE.branco}`,
                span: {
                  background: PALETTE.preto
                }
              }
            }
          },
          TempoServicoInfo: {
            box: {
              color: PALETTE.branco,
              backgroundColor: PALETTE.preto
            },
            value: {
              color: PALETTE.branco
            }
          },
        },
        Empregos: {
          titulo: PALETTE.branco
        }
      },
      simuladoEmprestimo:{
        color:PALETTE.branco,
        linkColor:PALETTE.amarelo
      },
      sobre: {
        Sobre: {
          mailSuporte: {
            color: PALETTE.branco
          }
        }
      },


    },
    painel: {
      home: {
        greetingsBox: {
          color: PALETTE.branco
        }
      },
      Footer: {
        footer: {
          background: '#000',
        }
      },
      component: {
        dashboard: {
          template: {
            List: {
              root: {
                backgroundColor: PALETTE.preto,
                color: ''
              },
              title: {
                color: PALETTE.branco,
              }
            },
            MiSearch: {
              searchContainer: {
                i: {
                  color: PALETTE.branco
                },
                borderColor: PALETTE.branco,
              },
              suggestion: {
                hover: {
                  backgroundColor: PALETTE.preto,
                  borderLeft: `4px solid ${PALETTE.amarelo}`
                }
              }
            },
            MainBar: {
              appBarDesktop: {
                span: {
                  borderLeft: ''
                },
              },
              menuContainer: {
                backgroundColor: PALETTE.preto,
                borderBottom: `1px solid ${PALETTE.branco}`
              },
              servicosBtnActive: {
                backgroundColor: PALETTE.preto
              },
              menuRight: {
                backgroundColor: '#202124'
              },
              hover: {
                backgroundColor: '#202124'
              },
              acessibilidade: {
                borderLeft: ''
              }
            },
          }
        },
        drawer: {
          SideMenu: {
            exitIcone: {
              color: PALETTE.branco
            }
          }
        },
        newdashboard: {
          DashboardComBeneficio: {
            vermais: {
              color: PALETTE.amarelo,
              iconColor: '#fff'
            }
          },
          DashboardSemBeneficio: {
            vermais: {
              color: PALETTE.amarelo,
              iconColor: '#fff'
            }
          },
        }
      }
    },
    shared: {
      component: {
        NitContainer: {
          pointer: {
            color: PALETTE.amarelo
          },
          container: {
            color: PALETTE.branco
          }
        }
      },
      template: {
        AppFooter: {
          footer: {
            backgroundColor: PALETTE.preto,
          }
        },
        AppTitleDesktop: {
          icoHome: {
            color: PALETTE.branco,
          },
          icoChevron: {
            color: PALETTE.branco,
          }
        },
        Blockquote: {
          inlineError: {
            borderLeft: `5px solid ${PALETTE.branco}`,
            backgroundColor: PALETTE.preto,
            color: PALETTE.branco
          },
          inlineWarning: {
            borderLeft: `5px solid ${PALETTE.branco}`,
            backgroundColor: PALETTE.preto
          },
          inlineInfo: {
            borderLeft: `5px solid ${PALETTE.branco}`,
            backgroundColor: PALETTE.preto,
          },
          inlineSuccess: {
            borderLeft: `5px solid ${PALETTE.branco}`,
            backgroundColor: PALETTE.preto,
          }
        },
        Card: {
          cover: {
            backgroundColor: '#202124',
          },
          card_title: {
            color: PALETTE.amarelo
          },
          card_icon: {
            color: ''

          }
        },
        CardWithIcon: {
          cover: {
            backgroundColor: '#202124',
          },
          card_title: {
            color: PALETTE.amarelo
          },
          card_icon: {
            color: ''

          }
        },
        CardButtonWithIconLeft: {
          card: {
            backgroundColor: "#fff",
          },
          content: {
            color: "#777",
          },
          icon: {
            color: PALETTE.branco,
          },
          text: {
            color: "#333333",
          },
        },

        GrupoDeDados: {
          card_title: {
            color: PALETTE.amarelo
          }
        },
        InfoScreen: {
          container: {
            color: PALETTE.branco
          },
          primaryText: {
            color: PALETTE.branco
          },
          secondaryText:{
            color:PALETTE.branco
          },
          card:{
            backgroundColor:"#202124"
          }
        },
        MeuINSSDescricao: {
          descricao: {
            color: PALETTE.branco
          }
        },
        MeuInssLabelValue: {
          meu_inss_label: {
            color: PALETTE.branco
          },
          meu_inss_value: {
            color: PALETTE.branco
          }
        },
        MeuInssSubtitle: {
          value: {
            color: PALETTE.amarelo
          }
        },
        WhiteBox: {
          root: {
            backgroundColor: PALETTE.preto,
            border: '1px solid #E0E0E0'
          }
        },
      }
    },
    typography: {

      fontFamily: [
        'Rawline',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      h2: {
        color: PALETTE.branco
      },
      body1: {
        color: '#FFFFFF !important'
      },
      fontSize: fontSize

    },
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
    },
    overrides: {
      MuiDialog: {
        root: {
          zIndex: 9999,
        },
      },
      PrivateTabIndicator: {
        colorPrimary: {
          backgroundColor: "#fff333 !important"
        }
      },
      MuiAvatar: {
        colorDefault: {
          color: PALETTE.preto,
          backgroundColor: `${PALETTE.branco} !important`
        }
      },
      MuiAlert: {
        message: {
          color: '#FFF'
        },
        icon: {
          '& i': {
            color: '#FFF !important'
          }
        }
      },
      MuiButton: {
        root: {
          background: 'transparent',
          border: `1px solid ${PALETTE.amarelo}`,
          borderRadius: '100em',          
          height: '48px',
          lineHeight: '40px',
          fontSize: '14px',
          fontWeight: '600',
          margin: 'auto',
          width: 'auto',
          padding: '0px',
          textTransform: 'none',
          whiteSpace: 'nowrap',
        },
        label: {
          marginLeft: '40px',
          marginRight: '40px',
          '&:hover': {
            color: PALETTE.amarelo,
          },
        },
        textPrimary: {
          color: PALETTE.branco
        },
        outlinedPrimary: {
          color: PALETTE.branco
        },
        containedPrimary: {
          color: PALETTE.preto,
          backgroundColor: PALETTE.amarelo,
          '&:active': {
            backgroundColor: PALETTE.branco,
            '& span': {
              color: PALETTE.preto
            }
          },
          '&:hover': {
            backgroundColor: PALETTE.preto,
            '& span': {
              color: PALETTE.amarelo
            }
          },
        },
        containedSecondary: {
          backgroundColor: "transparent",
          color: PALETTE.amarelo,
          "&:hover": {
            backgroundColor: "#424242",
          }
        },        
        text: {
          color: PALETTE.amarelo,
          padding: '0px',
        }
      },
      MuiCard: {
        root: {
          color: '#FFFFFF !important',
          borderLeftColor: '#FFFFFF !important'
        }
      },
      MuiCardHeader: {
        subheader: {
          color: PALETTE.branco
        }
      },
      MuiCardContent: {
        root: {
          color: '#FFFFFF !important'
        }
      },
      MuiCardActions: {
        root: {
          color: PALETTE.amarelo,
          '& a': {
            color: PALETTE.amarelo,
            '&:hover': {
              backgroundColor: PALETTE.preto
            },
          }  
        }
      },
      MuiExpansionPanel:{
        root:{
          backgroundColor:`000 !important`,        
        }
      },
      MuiExpansionPanelSummary:{
        root:{
          backgroundColor:`#000 !important`,        
        }
      },
      MuiFormLabel: {
        root: {
          color: PALETTE.branco,
          "&$focused": {
            color: PALETTE.branco,
          }
        }  
      },
      MuiIconButton: {
        root: {
          color: PALETTE.amarelo,
          '&:hover': {
            backgroundColor: 'none'
          }  
        }
      },
      MuiInputBase: {
        input: {
          color: PALETTE.branco,  
        },
      },
      MuiListItem: {
        root: {
          backgroundColor: '#000',
          color: PALETTE.branco
        },
        button: {
          '&:hover': {
            backgroundColor: PALETTE.preto
          }
        }
      }, 
      MuiListItemSecondaryAction: {
        root: {
          color: PALETTE.amarelo,
          height: '100%',
          display: "flex",
          alignItems: 'center'
        }  
      },   
      MuiOutlinedInput: {
        root: {
          backgroundColor: '#ffffff',
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: PALETTE.amarelo,
            borderWidth: '2px',
          },
        },
        input: {
          color: '#000000',
        }
      },
      MuiPaper: {
        root: {
          color: '#FFFFFF !important',
          backgroundColor: '#202124 !important'
        }
      },  
      MuiRadio: {
        colorPrimary: {
          color: `${PALETTE.amarelo} !important`
        }
      },
      MuiSkeleton: {
        root: {
          backgroundColor: PALETTE.branco
        }
      },
      MuiSvgIcon: {
        root: {
          fontSize:'1.728em'
        }
      },  
      MuiSwitch: {
        switchBase: {          
          color: '#ddd',
          '&.Mui-checked': {
            '& + .MuiSwitch-track': {
              opacity: '0.7'
            }
          }
        },
        track: {
          opacity: '0.5'
        }
      },
      MuiTab: {
        textColorInherit: {
          color: PALETTE.branco
        },
        textColorPrimary:{
          color:PALETTE.preto
        },      
      },  
      MuiTypography: {
        body1: {
          fontSize: "inherit"
        },
        subtitle1: {
          color: "#fff",
          textTransform: "none",
        }
      },         
      ServicosRecomendados: {
        backgroundColor: 'transparent !important',
      },
      AjudaHelo: {
        backgroundColor: '#000',
        color: `${PALETTE.amarelo} !important`,
        buttonColor: `${PALETTE.amarelo} !important`
      }
    },
  });
}
